import { render } from "./CmorGiornaliere.vue?vue&type=template&id=321ba909&scoped=true"
import script from "./CmorGiornaliere.vue?vue&type=script&lang=js"
export * from "./CmorGiornaliere.vue?vue&type=script&lang=js"

import "./CmorGiornaliere.vue?vue&type=style&index=0&id=321ba909&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-321ba909"]])

export default __exports__